//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CustomSwitch',
  props: {
    leftLabel: {
      type: String,
    },
    rightLabel: {
      type: String,
    },
    defaultValue: {
      type: Boolean,
    },
  },
  data() {
    return {
      modelValue: this.defaultValue,
    }
  },
  methods: {
    updateInput(value) {
      this.modelValue = value
      this.$emit('update', value)
    },
    updateSwitchValue(value){
      this.modelValue = value;
    }
  },
}
